import { UsersActionTypes } from '../Constants/UsersActionTypes'

const initialState = {
    users: {},
    validateSignUp: {},
    contentData: [],
    matchedLanguageFlag: false
}

export const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case UsersActionTypes.SET_USERS:
            return { ...state, users: action.payload }
        case UsersActionTypes.SET_VALIDATE_SIGNUP:
            return { ...state, validateSignUp: action.payload }
        case UsersActionTypes.SET_CONTENT_DATA:
            return { ...state, contentData: action.payload }
        case UsersActionTypes.SET_MATCHED_LANGUAGE_DATA:
            return { ...state, matchedLanguageFlag: action.payload }
        default:
            return state
    }
}

